const ru = {
  'workbench.v2.page.title': 'Рабочее место бухгалтера',
  'workbench.v2.page.subtitle': 'Выберите понятный бизнес-смысл операции — технические параметры система определит сама.',
  'workbench.v2.loading': 'Загрузка операций…',
  'workbench.v2.loadError': 'Не удалось загрузить операции.',
  'workbench.v2.openV1': 'Открыть текущий процесс',
  'workbench.v2.empty.title': 'Нет операций для обработки',
  'workbench.v2.empty.description': 'Новые операции появятся после загрузки банковской выписки.',
  'workbench.v2.transaction.label': 'Банковская операция',
  'workbench.v2.transaction.unnamed': 'Операция без описания',
  'workbench.v2.question': 'Что это за деньги?',
  'workbench.v2.questionHint': 'Сначала выберите, что произошло. Проведение начнётся только после вашего подтверждения в текущем процессе.',
  'workbench.v2.continue': 'Продолжить',
  'workbench.v2.notReady': 'Пока недоступно',
  'workbench.v2.salary.integrationReady': 'Можно выбрать сотрудника и проверить расчётный период. Отправка в iiko пока закрыта до завершения live UAT.',
  'workbench.v2.documentSettlement.unavailable': 'Отправка этой операции будет доступна после подключения безопасного обмена документами.',
  'workbench.v2.contour.PayableDocumentSettlement.label': 'Оплатили поставщику',
  'workbench.v2.contour.PayableDocumentSettlement.description': 'Оплата накладной или акта услуг.',
  'workbench.v2.contour.ReceivableDocumentSettlement.label': 'Получили оплату от клиента',
  'workbench.v2.contour.ReceivableDocumentSettlement.description': 'Оплата клиентской накладной или акта оказанных услуг.',
  'workbench.v2.contour.EmployeeSalaryPayment.label': 'Выплатили сотруднику',
  'workbench.v2.contour.EmployeeSalaryPayment.description': 'Зарплата или другая подтверждённая выплата сотруднику.',
  'workbench.v2.contour.SupplierAdvance.label': 'Аванс поставщику',
  'workbench.v2.contour.SupplierAdvance.description': 'Платёж поставщику без привязки к конкретному документу.',
  'workbench.v2.contour.InternalTransfer.label': 'Перевод между своими счетами',
  'workbench.v2.contour.InternalTransfer.description': 'Перемещение денег между счетами вашей организации.',
  'workbench.v2.contour.OtherBankOperation.label': 'Другая операция',
  'workbench.v2.contour.OtherBankOperation.description': 'Комиссия банка, налог, проценты или другая операция.',
  'workbench.v2.document.invoice': 'Накладная',
  'workbench.v2.document.serviceAct': 'Акт услуг',
  'workbench.v2.document.customerInvoice': 'Накладная клиенту',
  'workbench.v2.document.serviceProvision': 'Акт оказанных услуг',
};

const en: typeof ru = {
  'workbench.v2.page.title': 'Accountant workbench',
  'workbench.v2.page.subtitle': 'Choose the business meaning; the system keeps technical posting details out of the way.',
  'workbench.v2.loading': 'Loading transactions…',
  'workbench.v2.loadError': 'Could not load transactions.',
  'workbench.v2.openV1': 'Open current workflow',
  'workbench.v2.empty.title': 'No transactions to process',
  'workbench.v2.empty.description': 'New transactions appear after a bank statement is uploaded.',
  'workbench.v2.transaction.label': 'Bank transaction',
  'workbench.v2.transaction.unnamed': 'Transaction without description',
  'workbench.v2.question': 'What happened to the money?',
  'workbench.v2.questionHint': 'Choose the meaning first. Posting starts only after your confirmation in the current workflow.',
  'workbench.v2.continue': 'Continue',
  'workbench.v2.notReady': 'Not ready yet',
  'workbench.v2.salary.integrationReady': 'You can select an employee and verify the payroll period. Sending to iiko remains blocked until live UAT is complete.',
  'workbench.v2.documentSettlement.unavailable': 'Sending will be available after safe document exchange is connected.',
  'workbench.v2.contour.PayableDocumentSettlement.label': 'Paid a supplier',
  'workbench.v2.contour.PayableDocumentSettlement.description': 'Payment for an invoice or service act.',
  'workbench.v2.contour.ReceivableDocumentSettlement.label': 'Received a customer payment',
  'workbench.v2.contour.ReceivableDocumentSettlement.description': 'Payment for a customer invoice or service act.',
  'workbench.v2.contour.EmployeeSalaryPayment.label': 'Paid an employee',
  'workbench.v2.contour.EmployeeSalaryPayment.description': 'Salary or another confirmed employee payment.',
  'workbench.v2.contour.SupplierAdvance.label': 'Supplier advance',
  'workbench.v2.contour.SupplierAdvance.description': 'Payment to a supplier without linking a document.',
  'workbench.v2.contour.InternalTransfer.label': 'Transfer between own accounts',
  'workbench.v2.contour.InternalTransfer.description': 'Move money between your organization’s accounts.',
  'workbench.v2.contour.OtherBankOperation.label': 'Other transaction',
  'workbench.v2.contour.OtherBankOperation.description': 'Bank fee, tax, interest, or another transaction.',
  'workbench.v2.document.invoice': 'Invoice',
  'workbench.v2.document.serviceAct': 'Service act',
  'workbench.v2.document.customerInvoice': 'Customer invoice',
  'workbench.v2.document.serviceProvision': 'Service provision act',
};

const id: typeof ru = {
  'workbench.v2.page.title': 'Meja kerja akuntan',
  'workbench.v2.page.subtitle': 'Pilih makna bisnis; sistem menangani detail posting teknis.',
  'workbench.v2.loading': 'Memuat transaksi…',
  'workbench.v2.loadError': 'Transaksi tidak dapat dimuat.',
  'workbench.v2.openV1': 'Buka alur saat ini',
  'workbench.v2.empty.title': 'Tidak ada transaksi untuk diproses',
  'workbench.v2.empty.description': 'Transaksi baru muncul setelah laporan bank diunggah.',
  'workbench.v2.transaction.label': 'Transaksi bank',
  'workbench.v2.transaction.unnamed': 'Transaksi tanpa deskripsi',
  'workbench.v2.question': 'Apa yang terjadi dengan uang ini?',
  'workbench.v2.questionHint': 'Pilih maknanya terlebih dahulu. Posting dimulai hanya setelah konfirmasi Anda.',
  'workbench.v2.continue': 'Lanjutkan',
  'workbench.v2.notReady': 'Belum tersedia',
  'workbench.v2.salary.integrationReady': 'Anda dapat memilih karyawan dan memeriksa periode penggajian. Pengiriman ke iiko tetap diblokir hingga live UAT selesai.',
  'workbench.v2.documentSettlement.unavailable': 'Pengiriman tersedia setelah pertukaran dokumen aman dihubungkan.',
  'workbench.v2.contour.PayableDocumentSettlement.label': 'Membayar pemasok',
  'workbench.v2.contour.PayableDocumentSettlement.description': 'Pembayaran faktur atau dokumen layanan.',
  'workbench.v2.contour.ReceivableDocumentSettlement.label': 'Menerima pembayaran pelanggan',
  'workbench.v2.contour.ReceivableDocumentSettlement.description': 'Pembayaran faktur pelanggan atau dokumen layanan.',
  'workbench.v2.contour.EmployeeSalaryPayment.label': 'Membayar karyawan',
  'workbench.v2.contour.EmployeeSalaryPayment.description': 'Gaji atau pembayaran karyawan yang dikonfirmasi.',
  'workbench.v2.contour.SupplierAdvance.label': 'Uang muka pemasok',
  'workbench.v2.contour.SupplierAdvance.description': 'Pembayaran pemasok tanpa menghubungkan dokumen.',
  'workbench.v2.contour.InternalTransfer.label': 'Transfer antar rekening sendiri',
  'workbench.v2.contour.InternalTransfer.description': 'Pindahkan uang antar rekening organisasi Anda.',
  'workbench.v2.contour.OtherBankOperation.label': 'Transaksi lain',
  'workbench.v2.contour.OtherBankOperation.description': 'Biaya bank, pajak, bunga, atau transaksi lain.',
  'workbench.v2.document.invoice': 'Faktur',
  'workbench.v2.document.serviceAct': 'Dokumen layanan',
  'workbench.v2.document.customerInvoice': 'Faktur pelanggan',
  'workbench.v2.document.serviceProvision': 'Dokumen penyediaan layanan',
};

export const workbenchV2Translations = { ru, en, id };
